module.exports = __webpack_public_path__ + "img/nexperia-logo.3ea96f46.png";